export const getUpdatedMarks = (marks, value) => {
  let modifiedMarkKey = null;
  const updatedMarks = Object.keys(marks)
    .reverse()
    .reduce((newMarks, markKey) => {
      const parsedMarkKey = parseInt(markKey);
      const defaultMarkValue = marks[parsedMarkKey];
      if (
        parsedMarkKey !== 100 &&
        !modifiedMarkKey &&
        parseInt(value) >= parseInt(defaultMarkValue)
      ) {
        newMarks[parsedMarkKey] = value;
        modifiedMarkKey = parsedMarkKey;
      } else {
        newMarks[parsedMarkKey] = defaultMarkValue;
      }
      return newMarks;
    }, {});
  return [updatedMarks, modifiedMarkKey];
};
